import { ErrorBase } from '@piri/error';

export default class ToastError extends ErrorBase {
  static get key() {
    return 'ToastError';
  }
}
